import { MicroviewCommunicationChannel } from '../MicroviewCommunicationChannel';

export class SessionSiteUrlNameChannel extends MicroviewCommunicationChannel<void, { seassionSiteUrlName: string }> {
  public name: string = 'SessionSiteUrlNameChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class ExtractEncryptionEnabledOmniSwitchChannel extends MicroviewCommunicationChannel<void, { extractEncryptionEnabled: boolean }> {
  public name: string = 'ExtractEncryptionEnabledOmniSwitchChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class ExtractEncryptionModeForSiteChannel extends MicroviewCommunicationChannel<
  void,
  { extractEncryptionMode: ExtractEncryptionMode }
> {
  public name: string = 'ExtractEncryptionModeForSiteChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class CatalogOnsiteEnabledChannel extends MicroviewCommunicationChannel<void, { catalogOnsiteEnabled: boolean }> {
  public name: string = 'CatalogOnsiteEnabledChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class CollectionsEnabledChannel extends MicroviewCommunicationChannel<void, { collectionsEnabled: boolean }> {
  public name: string = 'CollectionsEnabledChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class MetricsOnSiteEnabledChannel extends MicroviewCommunicationChannel<void, { metricsOnSiteEnabled: boolean }> {
  public name: string = 'MetricsOnSiteEnabledChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class NlpServiceEnabledChannel extends MicroviewCommunicationChannel<void, { isNlpServiceEnabled: boolean }> {
  public name: string = 'NlpServiceEnabledChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class AskDataModeChannel extends MicroviewCommunicationChannel<void, { askDataMode: string }> {
  public name: string = 'AskDataModeChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class SessionUserIDChannel extends MicroviewCommunicationChannel<void, { sessionUserId: string }> {
  public name: string = 'SessionUserIDChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class IsSessionServerAdminChannel extends MicroviewCommunicationChannel<void, { isSessionServerAdmin: boolean }> {
  public name: string = 'IsSessionServerAdminChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class IsSessionSiteAdminChannel extends MicroviewCommunicationChannel<void, { isSessionSiteAdmin: boolean }> {
  public name: string = 'IsSessionSiteAdminChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class IsLimitedUserVisibilityChannel extends MicroviewCommunicationChannel<void, { isUserLimitedVisibility: boolean }> {
  public name: string = 'IsLimitedUserVisibilityChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class IsOnlineEnvironmentChannel extends MicroviewCommunicationChannel<void, { isOnlineEnvironment: boolean }> {
  public name: string = 'IsOnlineEnvironmentChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export class IsCollectionsEnabledOnSiteChannel extends MicroviewCommunicationChannel<void, { isCollectionsEnabledOnSite: boolean }> {
  public name: string = 'IsCollectionsEnabledOnSiteChannel';
  public namespace: string = 'VPC.SessionManagement';
}

export enum ExtractEncryptionMode {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  ENFORCED = 'enforced',
}
